import { SafePromise } from '@benzinga/safe-await';
import { ExtendedSubscribable } from '@benzinga/subscribable';

import { CoinData, CoinGeckoId, HowToBuyArticleData, PollData, VoteData, VoteParams } from './entities';
import { CryptoRequest, CryptoRestfulEvent } from './request';
import { Session } from '@benzinga/session';

export type CryptoManagerEvent = CryptoRestfulEvent;

interface CryptoFunctions {
  getCoin: CryptoManager['getCoin'];
  getCoins: CryptoManager['getCoins'];
}

export class CryptoManager extends ExtendedSubscribable<CryptoManagerEvent, CryptoFunctions> {
  private request: CryptoRequest;

  constructor(session: Session) {
    super();
    this.request = new CryptoRequest(session);
  }

  public static getName = () => 'benzinga-crypto';

  public getCoin = async (symbol: string): SafePromise<CoinData> => {
    return await this.request.getCoin(symbol);
  };

  public getCoins = async (symbols: string[]): SafePromise<CoinData[]> => {
    return await this.request.getCoins(symbols);
  };

  public getHowToBuyArticle = async (symbol: string): SafePromise<HowToBuyArticleData> => {
    return await this.request.getHowToBuyArticle(symbol);
  };

  public getNumberOfVotes = async (coinId: CoinGeckoId): SafePromise<PollData> => {
    return await this.request.getNumberOfVotes(coinId);
  };

  public postMOBVote = async (postData: VoteParams): SafePromise<VoteData> => {
    return await this.request.postMOBVote(postData);
  };

  protected onSubscribe(): CryptoFunctions {
    return {
      getCoin: this.getCoin,
      getCoins: this.getCoins,
    };
  }
}
